import { IReportServiceState } from "./model"

export const state: IReportServiceState = {
  applyTimeout: undefined,
  currentLaunchRequestId: 0
}
